package pl.michal_cyran.brand_hub.subpages.dayMathAd.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowDown
import com.varabyte.kobweb.silk.components.icons.fa.FaGooglePlay
import com.varabyte.kobweb.silk.components.icons.fa.FaScroll
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H6
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.HeroButtonsStyle
import pl.michal_cyran.brand_hub.HeroGridStyle
import pl.michal_cyran.brand_hub.components.widgets.DeviceMockup
import pl.michal_cyran.brand_hub.components.widgets.PrimaryButton
import pl.michal_cyran.brand_hub.components.widgets.SecondaryButton
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.toSitePalette


@Composable
fun DayMathHero() {
    val cm = ColorMode.current.toSitePalette()

    SimpleGrid(
        numColumns(base = 1, md = 2),
        HeroGridStyle.toModifier()
    ) {
        VisibilityAware(
            modifier = Modifier
        ) { isVisible ->
            Column {
                H6(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 0)
                        .toAttrs()
                ) {
                    Text("Twój osobysty korepetytor w kieszeni")
                }

                H1(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 120)
                        .toAttrs()
                ) {
                    SpanText(
                        "Opanuj maturę",
                        modifier = Modifier.color(cm.textMuted)
                    )
                    Br()
                    SpanText(
                        "bez stresu.",
                        modifier = Modifier.color(cm.primary)
                    )
                }

                P(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 240)
                        .toAttrs()
                ) {
                    Text(
                        "Nowoczesny Tutor to inteligentna platforma edukacyjna stworzona z myślą o maturzystach. Przygotuj się do egzaminu, ćwicząc w drodze do szkoły lub przy biurku."
                    )
                }

                Row(
                    HeroButtonsStyle.toModifier()
                        .revealFadeSlideUp(isVisible, delayMs = 360),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    PrimaryButton(
                        path = "https://play.google.com/store/apps/details?id=pl.ppistudio.daymath&hl=pl/",
                        text = "Pobierz z Google Play",
                        icon = { FaGooglePlay() },
                    )

                    SecondaryButton(
                        path = "#tests",
                        text = "Zobacz funkcje",
                        icon = { FaArrowDown() }
                    )
                }
            }
        }

        VisibilityAware(
            modifier = Modifier.width(100.percent)
        ) { isVisible ->
            Column(
                modifier = Modifier
                    .width(100.percent)
                    .revealFadeSlideUpScale(
                        isVisible,
                        delayMs = 200,
                        distance = 32.px,
                        fromScale = 0.92
                    ),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                DeviceMockup("daymath_ss/main")
            }
        }
    }
}